import React from 'react';

const PublicProfile = () => {
  return <h1>This is PublicProfile page.</h1>;
};

export default PublicProfile;
